/* eslint-disable */
import { useState, useEffect } from "react";
import { Observable } from "rxjs";

export function useHookSubscribe<T>(initValue: T, stream$?: Observable<T>, traceId?: string) {
  const [value, setValue] = useState<T>(initValue);
  useEffect(() => {
    const subscr = stream$?.subscribe((val) => {
      setValue(val);
      if (traceId) {
        console.log("next", traceId, val);
      }
    });
    if (traceId) {
      console.log("subscribe", traceId);
    }
    return () => {
      subscr?.unsubscribe();
      if (traceId) {
        console.log("unsubscribe", traceId);
      }
    };
  }, [stream$]);
  return value;
}
